import { State } from "../../types";

export type ReplaceSubstringsAction = Readonly<{
  type: "REPLACE SUBSTRINGS";
  substring: string;
  replacement: string;
}>;

export const replaceSubstrings = (
  state: State,
  _action: ReplaceSubstringsAction,
): State => {
  let blocks = {}
  Object.keys(state.blocks).forEach(key => {
    let updatedBlock = {
      ...state.blocks[key]
    }
    if (state.blocks[key].text) {
      const blockText : string = state.blocks[key].text;
      const replaced = blockText.replaceAll(_action.substring, _action.replacement);
      updatedBlock.text = replaced
    }
    blocks[key] = updatedBlock; 
  })

  return {
    ...state,
    blocks: blocks,
    substringInstances: 0,
  };
};
